import React from 'react';
import FormHelperText from "@mui/material/FormHelperText";
import Bubble from '../../Bubble.js';
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';

/**
 * 
 * @returns 
 */
const WaiveForBubbles = ({
  userData,
  reinstateFor,
  reinstateForError,
  setReinstateFor
}) => {
  const showMyselfAndDependents = userData.waiveFor === 'Self-Dependents';
  const showMyselfOnly = userData.waiveFor === 'Self-Dependents';
  const showDependents = userData.waiveFor === 'Dependents';
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      gap: '16px',
      // Set the spacing between the items
      width: '65%',
      height: 50
    }
  }, showMyselfAndDependents ? /*#__PURE__*/React.createElement(Bubble, {
    label: i18n.t(tokens.labels.signup.myselfAndDependents),
    isSelected: reinstateFor === 'Self-Dependents',
    onClick: () => reinstateFor !== "Self-Dependents" ? setReinstateFor("Self-Dependents") : setReinstateFor(false)
  }) : null, showMyselfOnly ? /*#__PURE__*/React.createElement(Bubble, {
    label: i18n.t(tokens.labels.signup.myselfOnly),
    isSelected: reinstateFor === 'Myself-Only',
    onClick: () => reinstateFor !== "Myself-Only" ? setReinstateFor("Myself-Only") : setReinstateFor(false)
  }) : null, showDependents ? /*#__PURE__*/React.createElement(Bubble, {
    label: i18n.t(tokens.labels.signup.dependentsOnly),
    isSelected: reinstateFor === 'Dependents',
    onClick: () => reinstateFor !== "Dependents" ? setReinstateFor("Dependents") : setReinstateFor(false)
  }) : null), /*#__PURE__*/React.createElement("div", null, reinstateForError ? /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, reinstateForError) : null));
};
export default WaiveForBubbles;